// import axios from 'axios';
import { LoginBasicPropConfig } from './LoginBasicPropConfig';
import { API_BASE_BASEPOINT, APIResourceConstants } from './api-constants';
import {
  OTP_SMS_OLD,
  OTP_SMS_NEW,
  OTP_SMS,
  OTP_EMAIL,
  OTP_NR_NEW,
  OTP_NR_LIST,
  PW_RESET
} from '../utils/constants';
import { v4 as generateUID } from 'uuid';

export enum USERNAME_TYPE {
  EMAIL = 'Email_Id',
  CLI = 'CLI',
  CUSTOMER_NUMBER = 'SiteID',
  MSISDN = 'MSISDN'
}

export interface LoginResponse {
  content: any;
  status: string;
}
export interface LoginMethodsResponse {
  ok: boolean;
  segment: string;
  username: string;
  allowedMethods: string[];
  isResidential: boolean;
  isSohoSmall: boolean;
  isMediumLargeCorporate: boolean;
  isMsisdn: boolean;
  errorCode?: string;
}

let source: any;

export const removeSpaces: (username: any) => string = (username: string | undefined | null) => {
  if (!username) {
    return '';
  }
  return username.replace(/\s+/g, '');
};

export const checkUsernameType: (username: string) => string | any = (username: string) => {
  if (username.length === 9 && /^[a|A]{0,1}[0-9]+$/.test(username)) username = '0' + username;
  if (
    /^[a-zA-Z0-9.!#$%&’*+\=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      String(username).toLowerCase()
    ) ||
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      String(username).toLowerCase()
    )
  ) {
    return USERNAME_TYPE.EMAIL;
  } else if (
    /^07[5-9][0-9]{7}$/gi.test(username) ||
    /^00417[6-9][0-9]{7}$/gi.test(username) ||
    /^0417[6-9][0-9]{7}$/gi.test(username) ||
    /^\+417[6-9][0-9]{7}$/gi.test(username) ||
    /^004107[6-9][0-9]{7}$/gi.test(username) ||
    /^04107[6-9][0-9]{7}$/gi.test(username) ||
    /^\+4107[6-9][0-9]{7}$/gi.test(username)
  ) {
    return USERNAME_TYPE.MSISDN;
  } else if (
    /^0[1-9][0-9]{8}$/gi.test(username) ||
    /^0041[1-9][0-9]{8}$/gi.test(username) ||
    /^041[1-9][0-9]{8}$/gi.test(username) ||
    /^\+41[1-9][0-9]{8}$/gi.test(username) ||
    /^00410[1-9][0-9]{8}$/gi.test(username) ||
    /^0410[1-9][0-9]{8}$/gi.test(username) ||
    /^\+410[1-9][0-9]{8}$/gi.test(username)
  ) {
    return USERNAME_TYPE.CLI;
  } else if (
    (username.toLowerCase().startsWith('a') && /^A|a[0-9]{10}$/gi.test(username)) ||
    /^[0-9]{10}$/gi.test(username)
  ) {
    return USERNAME_TYPE.CUSTOMER_NUMBER;
  } else {
    return undefined;
  }
};

export const getFormattedUsername = (username: string) => {
  username = username.replace(/\s/g, '');
  const userType: string | undefined = checkUsernameType(username);
  if (userType && userType !== USERNAME_TYPE.EMAIL) {
    if (username.length > 10 && username.startsWith('0041')) {
      const formattedNumber: string = username.replace('0041', '');
      return formattedNumber.startsWith('0') ? formattedNumber : '0' + formattedNumber;
    } else if (username.length > 10 && username.startsWith('+41')) {
      const formattedNumber: string = username.replace('+41', '');
      return formattedNumber.startsWith('0') ? formattedNumber : '0' + formattedNumber;
    } else if (username.length > 10 && username.startsWith('041')) {
      const formattedNumber: string = username.replace('041', '');
      return formattedNumber.startsWith('0') ? formattedNumber : '0' + formattedNumber;
    } else if (
      username.length === 9 &&
      !/^[a-zA-Z]/.test(username) &&
      !username.startsWith('0') &&
      !username.startsWith('0041') &&
      !username.startsWith('+41') &&
      !username.match(/^(?:00|\+)[0-9]{1,2}/)
    ) {
      return '0' + username;
    } else if (
      !/^[a-zA-Z]/.test(username) &&
      checkUsernameType(username) === USERNAME_TYPE.CUSTOMER_NUMBER &&
      (!username.startsWith('+') || (username.length === 10 && username.startsWith('00')))
    ) {
      return 'A' + username;
    } else {
      return username;
    }
  } else {
    return username;
  }
};

export const isValidEmail = (email: string) => {
  const re: any =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const isValidSiteId = (username: string) => {
  const siteidRE: any = /^[a|A]{0,1}[0-9]+$/;
  if (username.length < 10 || (username.length !== 10 && !siteidRE.test(username))) {
    return false;
  } else {
    if (siteidRE.test(username)) {
      if (username.startsWith('a') || username.startsWith('A')) {
        return username.length === 11;
      } else {
        return siteidRE.test(username) && username.length === 10;
      }
    } else return false;
  }
};

export const changeUserNameFormat: (username: string) => string = (username: string) => {
  const formattedUsername: string = getFormattedUsername(username);
  const numberCheck: string | undefined = checkUsernameType(formattedUsername);
  if (
    numberCheck &&
    numberCheck !== USERNAME_TYPE.EMAIL &&
    numberCheck !== USERNAME_TYPE.CUSTOMER_NUMBER
  ) {
    const isCountryCode: RegExpMatchArray | null = username.match(
      /^((?:0|00|\+)[0-9]{1,2})(\d{3})(\d{2})(\d{2})(\d{2})(\d{1,2})?$/
    );
    return insertSpacesInMsisdn(username, isCountryCode && isCountryCode.length > 0 ? true : false);
  } else return username;
};

const countryCodeTokenPosition: (msisdn: string) => number[] = (msisdn: string) => {
  if (/^0041[1-9][0-9]{8}$/gi.test(msisdn)) {
    return [4, 6, 9, 11];
  } else if (/^00410[1-9][0-9]{8}$/gi.test(msisdn)) {
    return [4, 7, 10, 12];
  } else if (/^0410[1-9][0-9]{8}$/gi.test(msisdn) || /^\+410[1-9][0-9]{8}$/gi.test(msisdn)) {
    return [3, 6, 9, 11];
  } else {
    return [3, 5, 8, 10];
  }
};

const insertSpacesInMsisdn: (msisdn: string | undefined | null, countryCode?: boolean) => string = (
  msisdn: string | undefined | null,
  countryCode?: boolean
) => {
  const isCountryCode: number[] = countryCode
    ? countryCodeTokenPosition(msisdn ? msisdn.replace(/\s+/g, '') : '')
    : msisdn?.length === 9
    ? [2, 5, 7]
    : [3, 6, 8];
  return insertToken(msisdn, ' ', isCountryCode);
};

export const insertToken: (
  originalString: string | undefined | null,
  token: string,
  tokenPositions: number[]
) => string = (
  originalString: string | undefined | null,
  token: string,
  tokenPositions: number[]
) => {
  if (originalString === 'undefined' || !originalString) return '';
  const withoutToken: string = originalString.split(token).join('');
  let withTokens: string = '';
  for (let i: number = 0; i < withoutToken.length; i++) {
    if (tokenPositions.includes(i)) {
      withTokens += token;
    }
    withTokens += withoutToken[i];
  }
  return withTokens;
};

export const replacePlaceholder = (source: string, params: string[]) => {
  const text: string = source?.replace(
    /{\w+}/g,
    (placeholder: any) => params[placeholder.substring(1, placeholder?.length - 1)] || placeholder
  );
  return text;
};

export const MyPolicyCallByAction = async (
  action: string,
  payload?: string,
  controllerRef?: any
) => {
  if (source) {
    source.cancel('Operation cancelled due to new request');
  }
  // source = axios.CancelToken.source();
  const loginBasicConfig = LoginBasicPropConfig?.getInstance();
  const endPoint = loginBasicConfig?.getBaseUrl();
  if (controllerRef.current) {
    controllerRef.current.abort();
  }
  controllerRef.current = new AbortController();
  const signal = controllerRef.current.signal;
  if (endPoint) {
    const postData: URLSearchParams = new URLSearchParams();
    if (action) postData.append('action', action);
    if (payload && [OTP_SMS_OLD, OTP_SMS_NEW, OTP_SMS, OTP_EMAIL]?.includes(action)) {
      postData.append('otp', payload);
    }
    if (payload && action === OTP_NR_NEW) postData.append('msisdn', payload);
    if (payload && action === OTP_NR_LIST) postData.append('recipient', payload);
    if (payload && action === PW_RESET) postData.append('password', payload);
    try {
      const response = await fetch(`${endPoint}${API_BASE_BASEPOINT?.LOGINPOLICY}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-correlation-id': generateUID(),
          'x-sunrise-channel': APIResourceConstants.X_SUN_CHAL
        },
        body: postData.toString(),
        signal: signal
      });

      const data = await response.json();
      if (data && data?.status) {
        return data;
      } else {
        const errorCode: string = data && (data?.errorcode || data?.errorCode);
        return errorCode;
      }
    } catch (error) {
      return error;
    }
  }
};

export const loginCalls = async (
  action: string,
  ApiEndPoint: string,
  username: string,
  password: string,
  controllerRef: any,
  lang?: string,
  rememberMe?: boolean
) => {
  if (source) {
    source.cancel('Operation cancelled due to new request');
  }
  // source = axios.CancelToken.source();
  if (controllerRef.current) {
    controllerRef.current.abort();
  }
  controllerRef.current = new AbortController();
  const signal = controllerRef.current.signal;
  const loginBasicConfig = LoginBasicPropConfig?.getInstance();
  const endPoint = loginBasicConfig?.getBaseUrl();
  if (endPoint) {
    const postData: URLSearchParams = new URLSearchParams();
    if (action) postData.append('action', action);
    if (username) postData.append('username', username);
    if (lang) postData.append('language', lang);
    if (password) postData.append('password', password);
    // if (action === 'PW_FORGOT') postData.append('forgotpassword', true.toString());
    if (rememberMe) postData.append('remember', rememberMe.toString());
    try {
      const response = await fetch(`${endPoint}${ApiEndPoint}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-correlation-id': generateUID(),
          'x-sunrise-channel': APIResourceConstants.X_SUN_CHAL
        },
        body: postData.toString(),
        signal: signal
      });

      const data = await response.json();
      if (data && data?.status) {
        return data;
      } else {
        const errorCode: string = data && (data?.errorcode || data?.errorCode);
        return errorCode;
      }
    } catch (error) {
      return error;
    }
  }
};

export const fetchAndUpdateChatToken = async (): Promise<void> => {
  try {
    const loginBasicConfig = LoginBasicPropConfig?.getInstance();
    const endPoint = loginBasicConfig?.getBaseUrl();
    if (!endPoint) return;

    const response = await fetch(`${endPoint}${API_BASE_BASEPOINT?.CHATTOKEN}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      console.warn('Failed to fetch chat token:', response.status);
      return;
    }

    const data = await response.json();

    if (data?.status === 'OK' && data?.token && data?.hash) {
      if (typeof window?.sprChat === 'function') {
        window.sprChat('updateUserSettings', {
          customUser: {
            client_assertion: data.token,
            hash: data.hash,
          },
        });
      }
    }
  } catch (error) {
    console.error('Error fetching chat token:', error);
  }
};
